import { Injectable } from '@angular/core';
import { Time } from 'highcharts';
import { Observable, map } from 'rxjs';
import { BaseApi } from './base.api';

@Injectable({
  providedIn: 'root',
})
export class TimeApi extends BaseApi {
  endpoint = 'time';

  getTime(timeZone: string = 'Europe/Stockholm'): Observable<string> {
    const url = this.generateUrl();
    const params = { timeZone: timeZone.replace('/', '%2F') };
    return this.http.get<Time>(url, { params }).pipe(map((response: any) => response.dateTime));
  }
}
